<template>
    <nav class="navbar navbar-expand-lg navbar-light bg-default">
        <!-- Container wrapper -->
        <div class="container-fluid">
            <!-- Toggle button -->
            <hamburger />

            <!-- Collapsible wrapper -->
            <div class="collapse navbar-collapse">

            </div>
            <!-- Collapsible wrapper -->

            <!-- Right elements -->
            <div class="d-flex align-items-center">
                <a class="nav-item" href="/login">Login</a>
            </div>
            <!-- Right elements -->
        </div>
        <!-- Container wrapper -->
    </nav>
</template>

<script>

export default {
    name: "AppNav",
}

</script>

